import type { NamePool } from "@/core/types.js";
export const zaNamePool: NamePool = {
  given: {
    male: ["Sipho","Thabo","Mandla","Bongani","Siyanda","Lethiwe","Sandile","Nhlanhla","Muzi","Musa","Johan","Pieter","Christiaan","Wilhelm","Andries","Michael","David","James","John","Robert"],
    female: ["Nomvula","Zanele","Thandi","Lindiwe","Ntombi","Zodwa","Nosipho","Nandi","Phindile","Sithembile","Annelie","Marietjie","Suzette","Elsa","Hanlie","Mary","Sarah","Grace","Faith","Hope"],
  },
  family: ["Dlamini","Nkosi","Mthembu","Zulu","Ndlovu","Khumalo","Nxumalo","Mahlangu","Mazibuko","Mkhize","Van der Merwe","Botha","Pretorius","Venter","Du Plessis","Nel","Fourie","Steyn","Coetzee","Naidoo"],
};
